import { logout } from '../../store/user'

import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

export const LogoutButton = () => {
    const dispatch = useDispatch()
    const history = useHistory()

    return (
        <button
            onClick={() => {
                dispatch(logout())
                localStorage.removeItem('userId')
                localStorage.removeItem('session')
                history.push('/')
            }}
        >
            Logout
        </button>
    )
}
